// trim jakby nie było
if (!String.prototype.trim) {
  String.prototype.trim = function () {
    //return this.replace(/^\s+|\s+$/g,'');
    var str = this.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    return str;
  };
}
// clean dla wielokrotnych spacji
if (!String.prototype.pkoClean) {
  String.prototype.pkoClean = function () {
    return this.replace(/\s+/g, ' ');
  };
}

// console dla złych przeglądarek
( function () {
  var method,
    noop = function () {
    },
    methods = [
      'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
      'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
      'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
      'timeStamp', 'trace', 'warn'
    ],
    length = methods.length;
  if (!window.console) {
    window.console = window.console || {};
  }
  while (length--) {
    method = methods[length];
    // Only stub undefined methods.
    if (!window.console[method]) {
      window.console[method] = noop;
    }
  }
}() );

// log jako moduł
// define( function( ) {

//     var log = function( ) {
//         // log.history = log.history || [ ];
//         // log.history.push( arguments );
//         if ( this.console ) {
//             if ( typeof console.log === 'object' ) {
//                 log.apply.call( console.log, console, Array.prototype.slice.call( arguments ) );
//             } else {
//                 console.log.apply( console, Array.prototype.slice.call( arguments ) );
//             }
//         }
//     };

//     return log;

// } );



// WEBPACK FOOTER //
// ./_front/_inteligo/js/shared/set-up.js